<template>
  <layout-print />
</template>

<script setup>
import * as dashboard from '@/dashboards'
import { layouts } from 'frontendcommon-3'
import { useShellStore } from '@/store'
import { computed, onMounted, watch } from 'vue'
const { LayoutPrint } = layouts

const shellStore = useShellStore()
const customization = computed(() => shellStore.customization)
const customCss = computed(() => customization.value ? customization.value.colors : dashboard.frontendcommonCss)

function injectCustomCss (id = 'initial-style') {
  const oldStyle = document.getElementById(id)
  if (oldStyle) document.head.removeChild(oldStyle)
  const style = document.createElement('style')
  style.id = id
  style.appendChild(document.createTextNode(customCss.value))
  document.head.appendChild(style)
}

watch(customCss, () => injectCustomCss('customization-style'))

onMounted(() => {
  injectCustomCss()
})
</script>
